import {_Sitemap} from '@localization/siteMap/breadcrumbs/_Sitemap.ts';
import {OpenInNew} from "@mui/icons-material";
import {Paper} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {PermissionableButton} from "@shared/specialComponents/PermissionableButton.tsx";
import {_SitemapOrcamentos} from "@localization/siteMap/breadcrumbs/_Sitemap.Orcamentos.ts";

export const SolicitacoesIndexPage = () => {
    const {solicitacoes} = _Sitemap;
    const {children} = solicitacoes;
    return (
        <DefaultContainer titulo={'Solicitacoes'}
                          size={'medium'}
                          component={Paper}>

            <PermissionableButton permission={
                ['VisualizarSolicitacoesMembro',
                    'VisualizarOrcamentos']}
                                  label={'Solicitações'}
                                  goTo={children.lista.fullUrl}
                                  icon={<OpenInNew/>}
            />
            <PermissionableButton permission={['VisualizarOrcamentos']}
                                  label={'Orçamentos'}
                                  goTo={_Sitemap.orcamento.children.lista.fullUrl}/>
            <PermissionableButton permission={['VisualizarOrcamentos', 'ConfirmarPagamento']}
                                  label={'Orçamentos(a pagar)'}
                                  goTo={_SitemapOrcamentos.children.a_pagar.fullUrl}/>
            <PermissionableButton permission={['VisualizarOrcamentos']}
                                  label={'Sinalizações'}
                                  goTo={_SitemapOrcamentos.children.flags.fullUrl}/>
            <PermissionableButton permission={['CriarTipoSolicitacao']}
                                  label={'Tipos de solicitações'}
                                  goTo={children.tipos.fullUrl}
                                  icon={<OpenInNew/>}
                                  fullWidth/>
        </DefaultContainer>
    );
};